import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';

import { actions } from './actions';

import * as auth from '../Auth/actions';

/* ------------- Application reducer ------------- */
const defaultState = {
  initialized: false,
};

/* eslint-disable complexity */
export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.INITIALIZE: {
      return state.merge({ initialized: true });
    }
    /* Show at least a loading screen when logging-in/out */
    case auth.actions.LOGIN: {
      return state.merge({ initialized: false });
    }
    case auth.actions.LOGIN_SUCCESS: {
      return state.merge({ initialized: true });
    }
    case auth.actions.LOGIN_FAILURE: {
      return state.merge({ initialized: true });
    }
    case auth.actions.LOGOUT: {
      return state.merge({ initialized: false });
    }
    case auth.actions.LOGOUT_END: {
      return state.merge({ initialized: true });
    }
    default: {
      return state;
    }
  }
}
/* eslint-enable complexity */

/* ------------- Application propTypes ------------- */
export const propTypes = {
  initialized: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/redux/Application/reducer.js